var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "documents") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "nc-icon-wrapper",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40,2.586V17a2,2,0,0,0,2,2H56.414Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.948,57.019A12.989,12.989,0,0,1,35,50H19a1,1,0,0,1,0-2H34.363A12.819,12.819,0,0,1,35,40H19a1,1,0,0,1,0-2H36.063A12.973,12.973,0,0,1,57,36.705V21H41a3,3,0,0,1-3-3V2H9A2,2,0,0,0,7,4V60a2,2,0,0,0,2,2H55a1.964,1.964,0,0,0,1.371-.559ZM19,18h9a1,1,0,0,1,0,2H19a1,1,0,0,1,0-2Zm0,10H45a1,1,0,0,1,0,2H19a1,1,0,0,1,0-2Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,35a10,10,0,1,0,5.509,18.337l6.37,6.37a1,1,0,0,0,1.414,0l1.414-1.414a1,1,0,0,0,0-1.414l-6.37-6.37A9.99,9.99,0,0,0,47,35Zm0,18a8,8,0,1,1,8-8A8.009,8.009,0,0,1,47,53Z",
    "data-color": "color-2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/documents.1085b5510e36c9f5be6bd88531a1fd02.svg";
export { ForwardRef as ReactComponent };